import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material';
import { SignOutIcon } from '@phosphor-icons/react/dist/ssr/SignOut';
import { vars } from '@tgtg/kit';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router';

import msg from './messages';

type UserMenuPopoverProps = {
  anchorEl: HTMLElement | null;
  isPopoverOpen: boolean;
  onPopoverClose: () => void;
};

const UserMenuPopover = ({ anchorEl, isPopoverOpen, onPopoverClose }: UserMenuPopoverProps) => {
  return (
    <Popover
      open={isPopoverOpen}
      anchorEl={anchorEl}
      onClose={onPopoverClose}
      anchorOrigin={{
        vertical: -12,
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: vars.radius.medium,
            boxShadow: vars.elevation.regular,
            minWidth: anchorEl?.offsetWidth,
          },
        },
      }}
    >
      <List disablePadding>
        <ListItem disablePadding>
          <ListItemButton
            component={NavLink}
            to='/logout'
            sx={{ paddingX: vars.spacing.neutral.xlarge, paddingY: vars.spacing.neutral.large }}
          >
            <ListItemIcon sx={{ minWidth: `calc(18px + ${vars.spacing.neutral.large})` }}>
              <SignOutIcon style={{ width: vars.size.medium, height: vars.size.medium }} />
            </ListItemIcon>
            <ListItemText
              primary={<FormattedMessage {...msg.signOut} />}
              primaryTypographyProps={{
                fontWeight: 500,
                fontFamily: vars.typography.labels.medium.fontFamily,
                fontSize: vars.typography.labels.medium.fontSize,
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Popover>
  );
};

export default UserMenuPopover;
